import { availableBackScrollPath } from '~/scriptData/common/routes/backRoutes'

const backScrollPosMixin = {
  data () {
    return {
      scrollPosition: {},
      savedHeight: {},
      isPopstate: false,
      scrollHeight: 0,
      exceptionHeight: 774,
      availablePath: availableBackScrollPath,
      isRestoringScroll: false
    }
  },
  created () {
    this.syncScrollAnchoring(this.$route.path)
  },
  watch: {
    $route: {
      handler (newValue, oldValue) {
        this.syncScrollAnchoring(newValue.path)

        // 실제로 route가 변경된 경우에만 처리 (같은 페이지에서 watcher 재호출 방지)
        // path만 비교하면 spexhbt처럼 식별자가 query(exbtNo)에 있는 페이지는
        // 전시가 바뀌어도 path가 동일해 여기서 전부 걸러져 저장/복원이 통째로 무시된다.
        if (oldValue && newValue.fullPath === oldValue.fullPath) {
          return
        }

        if (this.$store.getters['page/getPopstate']) {
          this.isPopstate = true
          this.scrollHeight = this.scrollPosition[this.$route.fullPath]?.height ?? 0
        } else {
          this.isPopstate = false
          if (oldValue && this.checkPath(oldValue.path)) {
            this.$set(this.scrollPosition, oldValue.fullPath, {})
            this.$set(this.scrollPosition[oldValue.fullPath], 'position', window.scrollY)
            this.$set(this.scrollPosition[oldValue.fullPath], 'height', document.documentElement.scrollHeight - this.exceptionHeight)
            sessionStorage.setItem('scrollPosition', JSON.stringify(this.scrollPosition))
          }
        }
      }
    }
  },
  updated () {
    if (!this.isPopstate || this.isRestoringScroll) {
      return
    }
    // checkMountedPath 대상 페이지는 실제 콘텐츠가 v-show로 숨겨진 채 비동기 mount 중일 수 있다.
    const isContentReady = !this.isIncludeCheckMounted || this.isCompletePageMount
    if (!isContentReady) {
      return
    }
    const savedScroll = this.scrollPosition[this.$route.fullPath]?.position ?? 0
    if (savedScroll > 0) {
      this.isRestoringScroll = true
      this.$nextTick(() => {
        this.restoreScrollUntilReady(savedScroll, Date.now())
      })
    }
  },
  methods: {
    checkPath (path) {
      const lowerPath = path.toLowerCase()
      return this.availablePath.some(element =>
        lowerPath === '/ds' ? true : lowerPath.includes(element.toLowerCase())
      )
    },
    // 기획전 상세(spexhbt) 구좌는 지연 로딩되며 콘텐츠가 뷰포트 안팎에서 계속 크기를
    // 바꾸는데, Chrome의 기본 scroll anchoring(overflow-anchor: auto)이 그때마다 "알아서"
    // scrollY를 보정해버린다. 실측(DevTools 스크립트로 scrollTo/scrollBy 호출 없이 scrollY가
    // 수백~수천px씩 저절로 움직이는 걸 확인 — docHeight가 그대로인데도 발생): 우리 쪽 복원
    // 로직(restoreScrollUntilReady)과 겹쳐 방향이 들쭉날쭉하게 튄다.
    // curation도 칩/이미지/무한스크롤이 같은 방식으로 비동기 로딩되며 동일 증상(기획전상세
    // 에서 뒤로가기 시 curation 스크롤이 복원되지 않고 이전 위치 그대로 보임)이 확인되어
    // spexhbt와 함께 끈다. 나머지 availablePath(diy/rank/exbt 등)는 아직 재현/검증 전이라
    // 영향 범위를 두 경로로만 최소화한다.
    // 전문관(speciallist) 추가
    syncScrollAnchoring (path) {
      if (typeof document === 'undefined') { return }
      const lowerPath = path.toLowerCase()
      const needsAnchorOff = lowerPath.includes('/ds/spexhbt') || lowerPath.includes('/ds/curation') || lowerPath.includes('/ds/specialist')
      document.documentElement.style.overflowAnchor = needsAnchorOff ? 'none' : ''
    },
    // 기획전 구좌 내부 상품리스트처럼 무한스크롤로 늦게 채워지는 콘텐츠가 있는 페이지는
    // 한 번의 scrollTo로 목표 위치까지 못 간다. scrollTo를 매 프레임 반복해서
    // 뷰포트에 들어온 하위 섹션의 지연로딩을 유도하며 목표 높이에 도달할 때까지 재시도한다.
    restoreScrollUntilReady (savedScroll, startedAt) {
      window.scrollTo(0, savedScroll)
      const maxScrollable = document.documentElement.scrollHeight - window.innerHeight
      const reached = maxScrollable >= savedScroll - 2
      const timedOut = Date.now() - startedAt > 2000 // 지연로딩 캐치업 대기는 최대 2초까지만
      if (reached || timedOut) {
        this.$delete(this.scrollPosition, this.$route.fullPath)
        sessionStorage.setItem('scrollPosition', JSON.stringify(this.scrollPosition))
        this.scrollHeight = 0
        this.isRestoringScroll = false
        return
      }
      requestAnimationFrame(() => this.restoreScrollUntilReady(savedScroll, startedAt))
    }
  }
}

export {
  backScrollPosMixin
}
